import { getErrorFormat } from 'core/utils/errors';
import { CommonAreaListResponseModel } from '../models/commonAreaEntityModels';
import { CommonAreaListResponsePayload } from '../models/payloadCommonAreaModels';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { payloadToCommonAreaList } from '../mappers';

const getUrl = ({
  host,
  projectId,
  page,
  size,
  search,
}: {
  host: string;
  projectId: string;
  page: number;
  size: number;
  search?: string;
}) => {
  const params = new URLSearchParams();
  page && params.append('page[number]', `${page}`);
  size && params.append('page[size]', `${size}`);
  !!search && params.append('search', search);

  return `${host}/projects/${projectId}/common-areas?${params}`;
};

export const GetCommonAreaListByProjectId = async ({
  host,
  token,
  projectId,
  page,
  size,
  search,
}: {
  host: string;
  token: string;
  projectId: string;
  page: number;
  size: number;
  search?: string;
}): Promise<CommonAreaListResponseModel> => {
  try {
    const url = getUrl({ host, projectId, page, size, search });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<CommonAreaListResponsePayload>;

    return payloadToCommonAreaList(data);
  } catch (error: any) {
    throw getErrorFormat(error);
  }
};
